module.exports = __webpack_public_path__ + "img/Z61Q_13.569b9a3a.jpg";